/**
 * One GST menu for every price an operator types (owner 2026-10-18: "all
 * amount include GST ... include the menu it Included. So that this question
 * never arise any where"). A rate and an included/added-on-top switch become
 * one choice; the default is the owner's: GST included at 18%.
 */
export type GstChoice = { gstratebp: number; priceincludesgst: boolean };

export const GST_INCLUDED_18: GstChoice = { gstratebp: 1800, priceincludesgst: true };

/** The menu's value for a choice: "incl:1800", "top:1800", "none". 0% is "none" either way. */
export function gstChoiceValue(c: GstChoice): string {
  if (c.gstratebp === 0) return "none";
  return `${c.priceincludesgst ? "incl" : "top"}:${c.gstratebp}`;
}

export function gstChoiceFromValue(v: string): GstChoice {
  if (v === "none") return { gstratebp: 0, priceincludesgst: true };
  const [mode, bp] = v.split(":");
  return { gstratebp: Number(bp), priceincludesgst: mode === "incl" };
}

export function gstChoiceLabel(c: GstChoice): string {
  if (c.gstratebp === 0) return "0% (no GST)";
  const pct = `${c.gstratebp / 100}%`;
  return c.priceincludesgst ? `Incl. ${pct} (GST inside the price)` : `${pct} (added on top)`;
}

/** The GST rates an Indian supply carries. */
export const GST_RATES_BP = [500, 1200, 1800, 2800] as const;

/**
 * The menu (owner 2026-10-18: "There is difference between 0% GST ... and
 * Incl. 18% ... It can be 5% or incl. of 5%"): 0%, then every rate added on
 * top and included -- plus the current choice if it is another rate, so
 * editing never loses it.
 */
export function gstChoiceOptions(current?: GstChoice | null): GstChoice[] {
  const base: GstChoice[] = [{ gstratebp: 0, priceincludesgst: true }];
  for (const bp of GST_RATES_BP) base.push({ gstratebp: bp, priceincludesgst: false }, { gstratebp: bp, priceincludesgst: true });
  if (current && !base.some((b) => gstChoiceValue(b) === gstChoiceValue(current))) base.push(current);
  return base;
}

/** "₹70.80 incl. GST" / "₹60.00 + 18% GST" / "₹50.00, no GST" -- how a stored price reads. */
export function gstPriceSuffix(c: GstChoice): string {
  if (c.gstratebp === 0) return "no GST";
  return c.priceincludesgst ? `incl. ${c.gstratebp / 100}% GST` : `+ ${c.gstratebp / 100}% GST`;
}
